import { useMemo } from 'react';

import {
  PIE_CHART_HEIGHT,
  OTHER_VALUE,
  COLOR_WHEEL,
  OTHER_COLOR,
  PIE_CHART_LEGEND_GAP,
} from '../constants';
import { PieChartData } from '../types';

export const getPiePositionProps = (
  containerWidth: number,
  containerHeight: number,
  _data: PieChartData,
) => {
  const pieChartRadius = PIE_CHART_HEIGHT / 2;

  // Calculate available space after accounting for the gap
  const availableWidth = containerWidth - PIE_CHART_LEGEND_GAP;

  // Position the chart in the left portion with its center slightly to the left
  // to account for the gap
  const chartCenterX = availableWidth / 2 - pieChartRadius - PIE_CHART_LEGEND_GAP;

  return {
    groupLeftOffset: chartCenterX,
    groupTopOffset: containerHeight / 2,
    pieChartRadius,
  };
};

export const useBisectPieData = (
  data: PieChartData,
  maxPrimaryDataLength: number,
): {
  colorWheel: string[];
  primaryData: PieChartData;
  secondaryData?: PieChartData;
  totalValue: number;
} => {
  const totalValue = useMemo(() => data.reduce((acc, curr) => acc + curr.value, 0), [data]);
  if (data.length > maxPrimaryDataLength) {
    const sortedData = data.sort((a, b) => b.value - a.value);
    const primaryData = [
      ...sortedData.slice(0, maxPrimaryDataLength - 1),
      {
        label: 'Other',
        name: OTHER_VALUE,
        value:
          totalValue -
          sortedData.slice(0, maxPrimaryDataLength - 1).reduce((acc, curr) => acc + curr.value, 0),
      },
    ];
    const secondaryData = data.slice(maxPrimaryDataLength - 1);

    return {
      colorWheel: [...COLOR_WHEEL.slice(0, data.length), OTHER_COLOR],
      primaryData,
      secondaryData,
      totalValue,
    };
  } else {
    return {
      colorWheel: COLOR_WHEEL,
      primaryData: data,
      totalValue,
    };
  }
};
